import React from 'react';

export const Arrow = ({ direction, color, width, height }) => {
  let dir = '90deg';
  switch (direction) {
    case 'right':
      dir = '-90deg';
      break;
    case 'top':
      dir = '180deg';
      break;
    case 'bottom':
      dir = '0deg';
      break;
    default:
      break;
  }
  return (
    <svg
      className={`mr-auto`}
      style={{ rotate: dir }}
      fill={color ?? 'black'}
      width={width ?? '16px'}
      height={height ?? '16px'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
    </svg>
  );
};
